import React, { useContext, useState } from "react";
import { Modal } from "react-bootstrap";
import DayInput from "react-day-picker/DayPickerInput";
import { toast } from "react-toastify";
import { Loading } from "../../components/Loading";

import { ModalContext } from "../../context/modal";
import { authApi } from "../../services/api";
import { DefaultButton, MyModalBody } from "../../style/default";
import { TOASTIFY_OPTIONS } from "../../style/global";
import { InputBlock, ModalContainer } from "./styles";

const UsageModal = ({ open, populateTable, data }) => {
	const { handleOpenModal } = useContext(ModalContext);

	const [selectedDay, setSelectedDay] = useState({
		initial: "",
		final: "",
	});
	const [loading, setIsLoading] = useState(false);

	const handleDayChange = (day, dayType) => {
		setSelectedDay({ ...selectedDay, [dayType]: day });
	};

	const handleReport = async () => {
		const hasChoosenFilters = Object.values(selectedDay);

		if (hasChoosenFilters.some((value) => value.length === 0)) {
			toast.error("Infome o filtro de data (inicial e final) corretamente!", {
				...TOASTIFY_OPTIONS,
				autoClose: 8000,
			});
			return;
		}

		try {
			setIsLoading(true);
			const response = await authApi.get(`/usage-report/${data._id}`, {
				params: {
					from: selectedDay.initial,
					to: selectedDay.final,
				},
				timeout: 0,
			});
			window.open(response.data.url);
			setIsLoading(false);
			handleOpenModal();
		} catch (error) {
			handleOpenModal();
			setIsLoading(false);
			console.error("error", error);
		}
	};

	return (
		<>
			{loading ? <Loading /> : null}
			<Modal
				transition={false}
				show={open}
				size="lg"
				backdrop="static"
				onHide={handleOpenModal}
			>
				<Modal.Header closeButton closeLabel="">
					<Modal.Title>
						Gerar relatório de uso da conta: {data?.name}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<MyModalBody>
						<ModalContainer>
							<InputBlock>
								<span>Data incial</span>
								<DayInput
									placeholder="Ex: 27/07/2021"
									onDayChange={(day) => handleDayChange(day, "initial")}
									dayPickerProps={{
										disabledDays: {
											after: new Date(),
										},
									}}
								/>
							</InputBlock>
							<InputBlock>
								<span>Data final</span>
								<DayInput
									placeholder="Ex: 07/08/2021"
									onDayChange={(day) => handleDayChange(day, "final")}
									dayPickerProps={{
										disabledDays: {
											before: selectedDay.initial,
											after: new Date(),
										},
									}}
								/>
							</InputBlock>
						</ModalContainer>
					</MyModalBody>
				</Modal.Body>
				<Modal.Footer>
					<DefaultButton onClick={handleReport}>Gerar relatório</DefaultButton>
				</Modal.Footer>
			</Modal>
		</>
	);
};

export { UsageModal };
